import React from 'react';
import { Link } from 'react-router-dom';
import appConfig from './../../appConfig';
const demoVideoUrl = 'https://uilqkfmzmvchwptxutgs.supabase.co/storage/v1/object/public/toolover/demo/videos/demo.mp4'

const { allFeatures } = appConfig;

const Home = () => {
  return (
  <div className="container px-4 pt-24 mx-auto md:pt-32 lg:px-0 dark:bg-gray-900">
    <h1 class="mb-4 text-center text-4xl font-extrabold leading-none tracking-tight text-gray-900 md:text-5xl lg:text-6xl dark:text-white">
      TOO<mark class="px-2 text-white bg-blue-600 rounded dark:bg-blue-500">lover</mark>
      &nbsp;Boost Your Work
    </h1>
    <p class="text-lg text-center font-normal text-gray-500 lg:text-xl dark:text-gray-400">
      All-in-one Toolbox for everyone, best tools for developers
    </p>
    <section className="grid grid-cols-1 space-y-12 md:space-y-0 md:grid-cols-1 lg:grid-cols-1 md:gap-x-6 md:gap-6 pt-9">
      <div className="flex items-center">
        <div className='w-1/12'></div>
        <video className="items-center w-10/12 h-auto border border-gray-200 rounded-lg dark:border-gray-700 videoStyle" controls>
          <source src={demoVideoUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </section>
    <section className="grid grid-cols-1 space-y-12 md:space-y-0 md:grid-cols-1 lg:grid-cols-1 md:gap-x-6 md:gap-6 pt-9">
      <h1 className="mb-4 text-center text-4xl font-extrabold leading-none tracking-tight text-gray-900 md:text-4xl lg:text-4xl dark:text-white">
        Where every tool finds its&nbsp;
        <span class="underline underline-offset-3 decoration-8 decoration-blue-400 dark:decoration-blue-600">LOVER</span>
      </h1>
      <h2 class="text-4xl text-center dark:text-white">
        <small class="ms-2 text-md font-normal text-gray-600 dark:text-gray-400">
          More tools available<br/>
          Secure your data, keeps your work safe<br/>
          Access our tools from anywhere, anytime<br/>
          Don't waste your time on unnecessary tasks <br/>
        </small>
      </h2>
    </section>
    <section className="grid grid-cols-1 space-y-12 md:space-y-0 md:grid-cols-1 lg:grid-cols-1 md:gap-x-6 md:gap-6 pt-9">
      {/* <h1 className="mb-4 text-center text-4xl font-extrabold leading-none tracking-tight text-gray-900 md:text-4xl lg:text-4xl dark:text-white">
        Our features
      </h1> */}
      <h1 class="mb-4 text-center text-3xl font-extrabold text-gray-900 dark:text-white md:text-5xl lg:text-6xl">
        Our&nbsp;
        <span class="text-transparent bg-clip-text bg-gradient-to-r to-emerald-600 from-sky-400">
          TOOLS
        </span>
        &nbsp;Here
      </h1>
      <div className="flex items-center">
        <div className='w-1/12' />
        <div class="w-10/12 h-full flex md-flex-row items-stretch">
          <div class="flex-1 flex flex-col space-y-2 justify-stretch md-items-end md-text-right pt-10">
            <h3 class="flex-none font-medium text-3xl mt-4">Text Tools</h3>
            <p class="flex-1 hero-container-width flex items-start md-justify-end">
              Utilities that allow you to create fancy text, change fonts for platforms like Facebook,
              and generate random text styles or characters...
            </p>
            <ul class="max-w-md space-y-1 text-gray-500 list-inside dark:text-gray-400">
              <li class="flex items-center">
                <svg class="w-3.5 h-3.5 me-2 text-green-500 dark:text-green-400 flex-shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
                </svg>
                Text Size Calculator
              </li>
              <li class="flex items-center">
                <svg class="w-3.5 h-3.5 me-2 text-green-500 dark:text-green-400 flex-shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
                </svg>
                Text Diff Checker
              </li>
              <li class="flex items-center">
                <svg class="w-3.5 h-3.5 me-2 text-green-500 dark:text-green-400 flex-shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
                </svg>
                Case Converter
              </li>
            </ul>
          </div>
          <div class="flex-none w-20 md-flex flex-col items-center pt-8">
            <div class="w-1 min-w-1 h-full min-h-full bg-black flex flex-col items-center">
              <div class="w-4 h-4 rounded-full bg-black -mt-2"></div>
            </div>
          </div>
          <div class="flex-1 h-full flex md-justify-start md-py-0 pt-8">
            <img class="fixed-height-120" src="/images/demo/text-tools.png" alt="Showcase text tools feature"/>
          </div>
        </div>
      </div>
      <div style={{marginTop: '-25px'}} className="flex items-center">
        <div className='w-1/12' />
        <div class="w-10/12 h-full flex md-flex-row items-stretch">
          <div class="flex-1 h-full flex md-justify-start md-py-0 pt-8">
            <img class="fixed-height-120" src="/images/demo/json-tools.png" alt="Showcase JSON tools feature"/>
          </div>
          <div class="flex-none w-20 md-flex flex-col items-center">
            <div class="w-1 min-w-1 h-full min-h-full bg-black flex flex-col items-center">
              <div class="w-4 h-4 rounded-full bg-black"></div>
            </div>
          </div>
          <div class="flex-1 flex flex-col space-y-2 justify-stretch md-items-end md-text-right pt-10">
            <h3 class="flex-none font-medium text-3xl mt-4">JSON Tools</h3>
            <p class="flex-1 hero-container-width flex items-start md-justify-end">
              Utilities designed to enhance working with JSON data, minify it for compact storage,
              query specific data, and visualize the structure using a tree view for easier navigation and analysis.
            </p>
            <ul class="max-w-md space-y-1 text-gray-500 list-inside dark:text-gray-400">
              <li class="flex items-center">
                <svg class="w-3.5 h-3.5 me-2 text-green-500 dark:text-green-400 flex-shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
                </svg>
                JSON Beautifier
              </li>
              <li class="flex items-center">
                <svg class="w-3.5 h-3.5 me-2 text-green-500 dark:text-green-400 flex-shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
                </svg>
                JSON Query
              </li>
              <li class="flex items-center">
                <svg class="w-3.5 h-3.5 me-2 text-green-500 dark:text-green-400 flex-shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
                </svg>
                JSON Tree Viewer
              </li>
              <li class="flex items-center">
                <svg class="w-3.5 h-3.5 me-2 text-green-500 dark:text-green-400 flex-shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
                </svg>
                Object (Ruby Hash) into JSON
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div style={{marginTop: '-25px'}} className="flex items-center">
        <div className='w-1/12' />
        <div class="w-10/12 h-full flex md-flex-row items-stretch">
          <div class="flex-1 flex flex-col space-y-2 justify-stretch md-items-end md-text-right pt-10">
            <h3 class="flex-none font-medium text-3xl mt-4">Random Tools</h3>
            <p class="flex-1 hero-container-width flex items-start md-justify-end">
              Generate arbitrary text content for testing or creative purposes...
            </p>
            <ul class="max-w-md space-y-1 text-gray-500 list-inside dark:text-gray-400">
              <li class="flex items-center">
                <svg class="w-3.5 h-3.5 me-2 text-green-500 dark:text-green-400 flex-shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
                </svg>
                Lorem Ipsum Generator
              </li>
              <li class="flex items-center">
                <svg class="w-3.5 h-3.5 me-2 text-green-500 dark:text-green-400 flex-shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
                </svg>
                Person Randomizer
              </li>
            </ul>
          </div>
          <div class="flex-none w-20 md-flex flex-col items-center">
            <div class="w-1 min-w-1 h-full min-h-full bg-black flex flex-col items-center">
              <div class="w-4 h-4 rounded-full bg-black"></div>
            </div>
          </div>
          <div class="flex-1 h-full flex md-justify-start md-py-0 pt-8">
            <img class="fixed-height-120" src="/images/demo/random-tools.png" alt="Showcase JSON tools feature"/>
          </div>
        </div>
      </div>
      <div style={{marginTop: '-25px'}} className="flex items-center">
        <div className='w-1/12' />
        <div class="w-10/12 h-full flex md-flex-row items-stretch">
          <div class="flex-1 h-full flex md-justify-start md-py-0 pt-8">
            <img class="fixed-height-120" src="/images/demo/developer-tools.png" alt="Showcase JSON tools feature"/>
          </div>
          <div class="flex-none w-20 md-flex flex-col items-center">
            <div class="w-1 min-w-1 h-full min-h-full bg-black flex flex-col items-center">
              <div class="w-4 h-4 rounded-full bg-black"></div>
            </div>
          </div>
          <div class="flex-1 flex flex-col space-y-2 justify-stretch md-items-end md-text-right pt-10">
            <h3 class="flex-none font-medium text-3xl mt-4">Developer Tools</h3>
            <p class="flex-1 hero-container-width flex items-start md-justify-end">
              Converting Excel data to JSON, explaining cron job schedules, testing regular expressions, and encoding or decoding Base64. These tools help developers work more efficiently with data formats, automation tasks, pattern matching, and data encoding.
            </p>
            <ul class="max-w-md space-y-1 text-gray-500 list-inside dark:text-gray-400">
              <li class="flex items-center">
                <svg class="w-3.5 h-3.5 me-2 text-green-500 dark:text-green-400 flex-shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
                </svg>
                Transform Excel into JSON
              </li>
              <li class="flex items-center">
                <svg class="w-3.5 h-3.5 me-2 text-green-500 dark:text-green-400 flex-shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
                </svg>
                Cron Job Parser
              </li>
              <li class="flex items-center">
                <svg class="w-3.5 h-3.5 me-2 text-green-500 dark:text-green-400 flex-shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
                </svg>
                Regex Tester
              </li>
              <li class="flex items-center">
                <svg class="w-3.5 h-3.5 me-2 text-green-500 dark:text-green-400 flex-shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
                </svg>
                Base64 Encode/ Decode
              </li>
              <li class="flex items-center">
                <svg class="w-3.5 h-3.5 me-2 text-green-500 dark:text-green-400 flex-shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
                </svg>
                QR Code Generator
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div style={{marginTop: '-25px'}} className="flex items-center">
        <div className='w-1/12' />
        <div class="w-10/12 h-full flex md-flex-row items-stretch">
          <div class="flex-1 h-full flex md-justify-start md-py-0">
          </div>
          <div class="flex-none w-20 md-flex flex-col items-center">
            <div class="w-1 min-w-1 h-full min-h-full bg-black flex flex-col items-center">
              <div class="w-4 h-4 rounded-full bg-black"></div>
            </div>
          </div>
          <div class="flex-1 flex flex-col space-y-2 justify-stretch md-items-end md-text-right pt-10">
            {/* <h3 class="flex-none font-medium text-3xl mt-4">… and more features</h3> */}
          </div>
        </div>
      </div>
      <section className="pt-20">
        <h2 className="mb-3 text-center text-6xl font-bold text-gray-900 sm:text-4xl sm:leading-none sm:tracking-tight dark:text-white">
          ... and more features
        </h2>
        <dl className="grid max-w-screen-xl grid-cols-2 gap-8 p-4 mx-auto text-gray-600 sm:grid-cols-2 xl:grid-cols-4 dark:text-white sm:p-8">
          { allFeatures.map((parentMenu) => {
            return (
              <div className="flex items-center flex-col hover:text-blue-700">
                <h1 className="text-xl hover:text-blue-700 font-semibold sm:text-xl dark:text-gray-200 transition duration-300 ease-in-out border-b-2 border-transparent hover:border-blue-700 animate-text-from-left">
                  <span className="inline-flex">{ parentMenu.icon }</span>
                  <span
                    className="inline-flex ml-1"
                  >
                    { parentMenu.name }
                  </span>
                </h1>
              </div>
            )
          }) }
        </dl>
        <hr className="my-6 border-gray-200 md:my-12 dark:border-gray-800" />   
      </section>
      {/* <div className="flex items-center">
        <div className='w-1/6' />
        <div className='w-4/6'>
          <ol className="relative border-s border-gray-200 dark:border-gray-700">
            <li className="mb-10 ms-6">
              <span className="absolute flex items-center justify-center w-6 h-6 bg-blue-100 rounded-full -start-3 ring-8 ring-white dark:ring-gray-900 dark:bg-blue-900">
                <svg
                  className="w-2.5 h-2.5 text-blue-800 dark:text-blue-300"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z" />
                </svg>
              </span>
              <h3 className="flex items-center mb-1 text-lg font-semibold text-gray-900 dark:text-white">
                Flowbite Application UI v2.0.0{" "}
                <span className="bg-blue-100 text-blue-800 text-sm font-medium me-2 px-2.5 py-0.5 rounded dark:bg-blue-900 dark:text-blue-300 ms-3">
                  Latest
                </span>
              </h3>
              <time className="block mb-2 text-sm font-normal leading-none text-gray-400 dark:text-gray-500">
                Released on January 13th, 2022
              </time>
              <p className="mb-4 text-base font-normal text-gray-500 dark:text-gray-400">
                Get access to over 20+ pages including a dashboard layout, charts, kanban
                board, calendar, and pre-order E-commerce &amp; Marketing pages.
              </p>
              <a
                href="#"
                className="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:outline-none focus:ring-gray-100 focus:text-blue-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-gray-700"
              >
                <svg
                  className="w-3.5 h-3.5 me-2.5"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M14.707 7.793a1 1 0 0 0-1.414 0L11 10.086V1.5a1 1 0 0 0-2 0v8.586L6.707 7.793a1 1 0 1 0-1.414 1.414l4 4a1 1 0 0 0 1.416 0l4-4a1 1 0 0 0-.002-1.414Z" />
                  <path d="M18 12h-2.55l-2.975 2.975a3.5 3.5 0 0 1-4.95 0L4.55 12H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2Zm-3 5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z" />
                </svg>{" "}
                Download ZIP
              </a>
            </li>
            <li className="mb-10 ms-6">
              <span className="absolute flex items-center justify-center w-6 h-6 bg-blue-100 rounded-full -start-3 ring-8 ring-white dark:ring-gray-900 dark:bg-blue-900">
                <svg
                  className="w-2.5 h-2.5 text-blue-800 dark:text-blue-300"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z" />
                </svg>
              </span>
              <h3 className="mb-1 text-lg font-semibold text-gray-900 dark:text-white">
                Flowbite Figma v1.3.0
              </h3>
              <time className="block mb-2 text-sm font-normal leading-none text-gray-400 dark:text-gray-500">
                Released on December 7th, 2021
              </time>
              <p className="text-base font-normal text-gray-500 dark:text-gray-400">
                All of the pages and components are first designed in Figma and we keep a
                parity between the two versions even as we update the project.
              </p>
            </li>
            <li className="ms-6">
              <span className="absolute flex items-center justify-center w-6 h-6 bg-blue-100 rounded-full -start-3 ring-8 ring-white dark:ring-gray-900 dark:bg-blue-900">
                <svg
                  className="w-2.5 h-2.5 text-blue-800 dark:text-blue-300"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z" />
                </svg>
              </span>
              <h3 className="mb-1 text-lg font-semibold text-gray-900 dark:text-white">
                Flowbite Library v1.2.2
              </h3>
              <time className="block mb-2 text-sm font-normal leading-none text-gray-400 dark:text-gray-500">
                Released on December 2nd, 2021
              </time>
              <p className="text-base font-normal text-gray-500 dark:text-gray-400">
                Get started with dozens of web components and interactive elements built
                on top of Tailwind CSS.
              </p>
            </li>
          </ol>
        </div>
      </div> */}
    </section>
    <section className="grid grid-cols-1 space-y-12 md:space-y-0 md:grid-cols-1 lg:grid-cols-1 md:gap-x-6 md:gap-6 pt-9">
      <h3 class="text-3xl text-center text-orange-500 font-bold dark:text-white">Ready to dive in?</h3>
      <h2 class="text-5xl text-center font-bold dark:text-white">
        Start now to see <br/><span class="text-blue-600 dark:text-blue-500">TOOlover</span> in action
      </h2>
      <div class="flex flex-col sm:flex-col md:flex-row lg:flex-row items-center justify-center gap-6">
        <a class="flex justify-start items-center rounded-full px-8 py-3 text-refular md:text-lg font-semibold text-white tracking-wide glowingDownloadBtn"
          href="/app"
        >
          Try now for FREE
        </a>
        {/* <a class="flex justify-start items-center rounded-full px-8 py-3 text-refular md:text-lg font-semibold text-slate-900 tracking-wide border-2 border-black" href="/app">Try now for FREE</a> */}
      </div>
    </section>
    {/* <h1 className="mb-3 text-3xl font-bold text-gray-900 sm:text-4xl sm:leading-none sm:tracking-tight dark:text-white">
      Our pricing plan made simple
    </h1>
    <p className="mb-6 text-lg font-normal text-gray-500 sm:text-xl dark:text-gray-400">
      All types of businesses need access to development resources, so we give
      you the option to decide how much you need to use.
    </p>
    <div className="flex items-center">
      <span className="text-base font-medium text-gray-900 dark:text-white">
        Monthly
      </span>
      <div>
        <label
          htmlFor="toggle-example"
          className="relative flex items-center mx-4 cursor-pointer"
        >
          <input type="checkbox" id="toggle-example" className="sr-only" />
          <div className="h-6 bg-gray-200 border border-gray-200 rounded-full toggle-bg w-11 dark:bg-gray-700 dark:border-gray-600" />
        </label>
      </div>
      <span className="text-base font-medium text-gray-500 dark:text-gray-400">
        Yearly
      </span>
    </div> */}
    {/* Pricing Cards */}
    {/* <section className="grid grid-cols-1 space-y-12 md:space-y-0 md:grid-cols-2 lg:grid-cols-3 md:gap-x-6 md:gap-6 pt-9">
      <div className="flex flex-col max-w-lg p-6 mx-auto text-gray-900 bg-white border border-gray-200 rounded-lg shadow-sm dark:border-gray-700 xl:p-8 dark:bg-gray-800 dark:text-white">
        <h3 className="mb-4 text-2xl font-semibold">Starter</h3>
        <p className="font-light text-gray-500 sm:text-lg dark:text-gray-400">
          Best option for personal use &amp; for your next project.
        </p>
        <div className="flex items-baseline my-8">
          <span className="mr-2 text-5xl font-extrabold">$29</span>
          <span className="text-gray-500 dark:text-gray-400">/month</span>
        </div>
        <ul role="list" className="mb-8 space-y-4 text-left">
          <li className="flex items-center space-x-3">
            <svg
              className="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
            <span>Individual configuration</span>
          </li>
          <li className="flex items-center space-x-3">
            <svg
              className="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
            <span>No setup, or hidden fees</span>
          </li>
          <li className="flex items-center space-x-3">
            <svg
              className="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
            <span>
              Team size: <span className="font-semibold">1 developer</span>
            </span>
          </li>
          <li className="flex items-center space-x-3">
            <svg
              className="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
            <span>
              Premium support: <span className="font-semibold">6 months</span>
            </span>
          </li>
          <li className="flex items-center space-x-3">
            <svg
              className="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
            <span>
              Free updates: <span className="font-semibold">6 months</span>
            </span>
          </li>
        </ul>
        <a
          href="#"
          className="text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:ring-primary-200 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:text-white  dark:focus:ring-primary-900"
        >
          Get started
        </a>
      </div>
      <div className="flex flex-col max-w-lg p-6 mx-auto text-gray-900 bg-white border border-gray-200 rounded-lg shadow-sm dark:border-gray-700 xl:p-8 dark:bg-gray-800 dark:text-white">
        <h3 className="mb-4 text-2xl font-semibold">Company</h3>
        <p className="font-light text-gray-500 sm:text-lg dark:text-gray-400">
          Relevant for multiple users, extended &amp; premium support.
        </p>
        <div className="flex items-baseline my-8">
          <span className="mr-2 text-5xl font-extrabold">$99</span>
          <span
            className="text-gray-500 dark:text-gray-400 dark:text-gray-400"
          >
            /month
          </span>
        </div>
        <ul role="list" className="mb-8 space-y-4 text-left">
          <li className="flex items-center space-x-3">
            <svg
              className="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
            <span>Individual configuration</span>
          </li>
          <li className="flex items-center space-x-3">
            <svg
              className="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
            <span>No setup, or hidden fees</span>
          </li>
          <li className="flex items-center space-x-3">
            <svg
              className="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
            <span>
              Team size: <span className="font-semibold">10 developers</span>
            </span>
          </li>
          <li className="flex items-center space-x-3">
            <svg
              className="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
            <span>
              Premium support:{" "}
              <span className="font-semibold">24 months</span>
            </span>
          </li>
          <li className="flex items-center space-x-3">
            <svg
              className="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
            <span>
              Free updates: <span className="font-semibold">24 months</span>
            </span>
          </li>
        </ul>
        <a
          href="#"
          className="text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:ring-primary-200 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:text-white  dark:focus:ring-primary-900"
        >
          Get started
        </a>
      </div>
      <div className="flex flex-col max-w-lg p-6 mx-auto text-gray-900 bg-white border border-gray-200 rounded-lg shadow-sm dark:border-gray-700 xl:p-8 dark:bg-gray-800 dark:text-white">
        <h3 className="mb-4 text-2xl font-semibold">Enterprise</h3>
        <p className="font-light text-gray-500 sm:text-lg dark:text-gray-400">
          Best for large scale uses and extended redistribution rights.
        </p>
        <div className="flex items-baseline my-8">
          <span className="mr-2 text-5xl font-extrabold">$499</span>
          <span className="text-gray-500 dark:text-gray-400">/month</span>
        </div>
        <ul role="list" className="mb-8 space-y-4 text-left">
          <li className="flex items-center space-x-3">
            <svg
              className="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
            <span>Individual configuration</span>
          </li>
          <li className="flex items-center space-x-3">
            <svg
              className="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
            <span>No setup, or hidden fees</span>
          </li>
          <li className="flex items-center space-x-3">
            <svg
              className="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
            <span>
              Team size:{" "}
              <span className="font-semibold">100+ developers</span>
            </span>
          </li>
          <li className="flex items-center space-x-3">
            <svg
              className="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
            <span>
              Premium support:{" "}
              <span className="font-semibold">36 months</span>
            </span>
          </li>
          <li className="flex items-center space-x-3">
            <svg
              className="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
            <span>
              Free updates: <span className="font-semibold">36 months</span>
            </span>
          </li>
        </ul>
        <a
          href="#"
          className="text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:ring-primary-200 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:text-white  dark:focus:ring-primary-900"
        >
          Get started
        </a>
      </div>
    </section> */}
    {/* Comparison Table */}
    {/* <section className="flex flex-col pt-10 md:pt-20">
      <div className="overflow-x-auto rounded-lg">
        <div className="inline-block min-w-full align-middle">
          <div className="overflow-hidden shadow sm:rounded-lg">
            <table className="min-w-full">
              <thead className="bg-gray-50 dark:bg-gray-900">
                <tr>
                  <th scope="col" className="p-4 text-left"></th>
                  <th
                    scope="col"
                    className="p-4 text-base font-semibold tracking-wider text-right text-gray-900 dark:text-white"
                  >
                    Freelancer
                  </th>
                  <th
                    scope="col"
                    className="p-4 text-base font-semibold tracking-wider text-right text-gray-900 dark:text-white"
                  >
                    Company
                  </th>
                  <th
                    scope="col"
                    className="p-4 text-base font-semibold tracking-wider text-right text-gray-900 dark:text-white"
                  >
                    Enterprise
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white dark:bg-gray-800">
                <tr>
                  <td className="p-4 text-base font-normal text-gray-500 rounded-l-lg whitespace-nowrap dark:text-gray-400">
                    Seperate business/personal
                  </td>
                  <td className="p-4">
                    <svg
                      className="w-5 h-5 ml-auto text-green-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </td>
                  <td className="p-4">
                    <svg
                      className="w-5 h-5 ml-auto text-green-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </td>
                  <td className="p-4 rounded-r-lg">
                    <svg
                      className="w-5 h-5 ml-auto text-green-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </td>
                </tr>
                <tr className="bg-gray-50 dark:bg-gray-900">
                  <td className="p-4 text-base font-normal text-gray-500 whitespace-nowrap dark:text-gray-400">
                    Estimate tax payments
                  </td>
                  <td className="p-4">
                    <svg
                      className="w-5 h-5 ml-auto text-green-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </td>
                  <td className="p-4">
                    <svg
                      className="w-5 h-5 ml-auto text-green-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </td>
                  <td className="p-4 rounded-r-lg">
                    <svg
                      className="w-5 h-5 ml-auto text-green-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </td>
                </tr>
                <tr>
                  <td className="p-4 text-base font-normal text-gray-500 rounded-l-lg whitespace-nowrap dark:text-gray-400">
                    Stock control
                  </td>
                  <td className="p-4">
                    <svg
                      className="w-5 h-5 ml-auto text-green-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </td>
                  <td className="p-4">
                    <svg
                      className="w-5 h-5 ml-auto text-green-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </td>
                  <td className="p-4 rounded-r-lg">
                    <svg
                      className="w-5 h-5 ml-auto text-green-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </td>
                </tr>
                <tr className="bg-gray-50 dark:bg-gray-900">
                  <td className="p-4 text-base font-normal text-gray-500 whitespace-nowrap dark:text-gray-400">
                    Create invoices &amp; estimates
                  </td>
                  <td className="p-4">
                    <svg
                      className="w-5 h-5 ml-auto text-red-500"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </td>
                  <td className="p-4">
                    <svg
                      className="w-5 h-5 ml-auto text-green-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </td>
                  <td className="p-4 rounded-r-lg">
                    <svg
                      className="w-5 h-5 ml-auto text-green-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </td>
                </tr>
                <tr>
                  <td className="p-4 text-base font-normal text-gray-500 rounded-l-lg whitespace-nowrap dark:text-gray-400">
                    Manage bills &amp; payments
                  </td>
                  <td className="p-4">
                    <svg
                      className="w-5 h-5 ml-auto text-red-500"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </td>
                  <td className="p-4">
                    <svg
                      className="w-5 h-5 ml-auto text-green-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </td>
                  <td className="p-4 rounded-r-lg">
                    <svg
                      className="w-5 h-5 ml-auto text-green-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </td>
                </tr>
                <tr className="bg-gray-50 dark:bg-gray-900">
                  <td className="p-4 text-base font-normal text-gray-500 whitespace-nowrap dark:text-gray-400">
                    Run payroll
                  </td>
                  <td className="p-4">
                    <svg
                      className="w-5 h-5 ml-auto text-red-500"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </td>
                  <td className="p-4">
                    <svg
                      className="w-5 h-5 ml-auto text-green-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </td>
                  <td className="p-4 rounded-r-lg">
                    <svg
                      className="w-5 h-5 ml-auto text-green-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </td>
                </tr>
                <tr>
                  <td className="p-4 text-base font-normal text-gray-500 rounded-l-lg whitespace-nowrap dark:text-gray-400">
                    Handle multiple currencies
                  </td>
                  <td className="p-4">
                    <svg
                      className="w-5 h-5 ml-auto text-red-500"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </td>
                  <td className="p-4">
                    <svg
                      className="w-5 h-5 ml-auto text-red-500"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </td>
                  <td className="p-4 rounded-r-lg">
                    <svg
                      className="w-5 h-5 ml-auto text-green-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </td>
                </tr>
                <tr className="bg-gray-50 dark:bg-gray-900">
                  <td className="p-4 text-base font-normal text-gray-500 whitespace-nowrap dark:text-gray-400">
                    Number of Users
                  </td>
                  <td className="p-4">
                    <div className="flex items-center justify-end space-x-1">
                      <svg
                        className="flex-shrink-0 w-5 h-5 text-gray-900 dark:text-white"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <span className="flex-shrink-0 text-xs font-medium text-gray-900 sm:text-sm md:text-base dark:text-white">
                        1 User
                      </span>
                    </div>
                  </td>
                  <td className="p-4">
                    <div className="flex items-center justify-end space-x-1">
                      <svg
                        className="flex-shrink-0 w-5 h-5 text-gray-900 dark:text-white"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
                      </svg>
                      <span className="flex-shrink-0 text-xs font-medium text-gray-900 sm:text-sm md:text-base dark:text-white">
                        5-10 Users
                      </span>
                    </div>
                  </td>
                  <td className="p-4 rounded-r-lg">
                    <div className="flex items-center justify-end space-x-1">
                      <svg
                        className="flex-shrink-0 w-5 h-5 text-gray-900 dark:text-white"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" />
                      </svg>
                      <span className="flex-shrink-0 text-xs font-medium text-gray-900 sm:text-sm md:text-base dark:text-white">
                        20+ Users
                      </span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="p-4 text-base font-normal text-gray-500 rounded-l-lg whitespace-nowrap dark:text-gray-400">
                    Track deductible mileage
                  </td>
                  <td className="p-4">
                    <svg
                      className="w-5 h-5 ml-auto text-red-500"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </td>
                  <td className="p-4">
                    <svg
                      className="w-5 h-5 ml-auto text-red-500"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </td>
                  <td className="p-4 rounded-r-lg">
                    <svg
                      className="w-5 h-5 ml-auto text-green-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </td>
                </tr>
                <tr className="bg-gray-50 dark:bg-gray-900">
                  <td className="p-4 text-base font-normal text-gray-500 whitespace-nowrap dark:text-gray-400">
                    Track employee time
                  </td>
                  <td className="p-4">
                    <svg
                      className="w-5 h-5 ml-auto text-red-500"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </td>
                  <td className="p-4">
                    <svg
                      className="w-5 h-5 ml-auto text-red-500"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </td>
                  <td className="p-4 rounded-r-lg">
                    <svg
                      className="w-5 h-5 ml-auto text-green-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </td>
                </tr>
                <tr>
                  <td className="p-4 text-base font-normal text-gray-500 rounded-l-lg whitespace-nowrap dark:text-gray-400">
                    Multi-device
                  </td>
                  <td className="p-4">
                    <svg
                      className="w-5 h-5 ml-auto text-red-500"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </td>
                  <td className="p-4">
                    <svg
                      className="w-5 h-5 ml-auto text-red-500"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </td>
                  <td className="p-4 rounded-r-lg">
                    <svg
                      className="w-5 h-5 ml-auto text-green-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section> */}
    <section className="pt-20">
      <h2 className="mb-3 text-center text-6xl font-bold text-gray-900 sm:text-4xl sm:leading-none sm:tracking-tight dark:text-white">
        Frequently asked questions
      </h2>
      <p className="mb-6 text-lg font-normal text-gray-500 sm:text-xl dark:text-gray-400">
        All types of businesses need access to development resources, so we
        give you the option to decide how much you need to use.
      </p>
      <hr className="my-6 border-gray-200 md:my-12 dark:border-gray-800" />
      <div className="grid gap-8 lg:grid-cols-2">
        <div>
          <h3 className="mb-4 text-lg font-medium text-gray-900 dark:text-white">
            How does support work?
          </h3>
          <p className="mb-4 text-gray-600 dark:text-gray-400">
            We're aware of the importance of well qualified support, that is
            why we decided that support will only be provided by the authors
            that actually worked on this project.
          </p>
          <p className="mb-4 text-gray-600 dark:text-gray-400">
            Feel free to{" "}
            <Link to='/contact' className="font-medium underline text-primary-600 hover:no-underline dark:text-primary-500">
              contact us
            </Link>
            &nbsp;and we'll help you out as soon as we can.
          </p>
        </div>
        <div>
          <h3 className="mb-4 text-lg font-medium text-gray-900 dark:text-white">
            What does "free updates" include?
          </h3>
          <p className="mb-4 text-gray-600 dark:text-gray-400">
            The free updates that will be provided is based on the{" "}
            <Link to='#' className="font-medium underline text-primary-600 hover:no-underline dark:text-primary-500">
            roadmap
            </Link>
            &nbsp;that we have laid out for this project. It is also possible that
            we will provide extra updates outside of the roadmap as well.
          </p>
        </div>
        <div>
          <h3 className="mb-4 text-lg font-medium text-gray-900 dark:text-white">
            Is my data protected?
          </h3>
          <p className="mb-4 text-gray-600 dark:text-gray-400">
            All data is kept locally on your machine, ensuring your privacy and peace of mind.
          </p>
        </div>
        <div>
          <h3 className="mb-4 text-lg font-medium text-gray-900 dark:text-white">
            What are the requirements to use TOOlover?
          </h3>
          <p className="mb-4 text-gray-600 dark:text-gray-400">
            Internet connection. TOOlover may need communicates with our server to generate responses for heavy tasks, a stable internet connection is required for smooth operation.
          </p>
        </div>
      </div>
      {/* <div className="grid gap-8 lg:grid-cols-3">
        <div>
          <div className="mb-10">
            <h3 className="mb-4 text-lg font-medium text-gray-900 dark:text-white">
              What do you mean by "Figma assets"?
            </h3>
            <p className="text-gray-600 dark:text-gray-400">
              You will have access to download the full Figma project
              including all of the pages, the components, responsive pages,
              and also the icons, illustrations, and images included in the
              screens.
            </p>
          </div>
          <div className="mb-10">
            <h3 className="mb-4 text-lg font-medium text-gray-900 dark:text-white">
              What does "lifetime access" exactly mean?
            </h3>
            <p className="mb-4 text-gray-600 dark:text-gray-400">
              Once you have purchased either the design, code, or both
              packages, you will have access to all of the future updates
              based on the roadmap, free of charge.
            </p>
          </div>
          <div className="mb-10">
            <h3 className="mb-4 text-lg font-medium text-gray-900 dark:text-white">
              How does support work?
            </h3>
            <p className="mb-4 text-gray-600 dark:text-gray-400">
              We're aware of the importance of well qualified support, that is
              why we decided that support will only be provided by the authors
              that actually worked on this project.
            </p>
            <p className="mb-4 text-gray-600 dark:text-gray-400">
              Feel free to{" "}
              <a
                href="#"
                className="font-medium underline text-primary-600 hover:no-underline dark:text-primary-500"
                target="_blank"
                rel="noreferrer"
              >
                contact us
              </a>{" "}
              and we'll help you out as soon as we can.
            </p>
          </div>
          <div className="mb-10">
            <h3 className="mb-4 text-lg font-medium text-gray-900 dark:text-white">
              I want to build more than one project with FlowBite. Is that
              allowed?
            </h3>
            <p className="mb-4 text-gray-600 dark:text-gray-400">
              You can use FlowBite for an unlimited amount of projects,
              whether it's a personal website, a SaaS app, or a website for a
              client. As long as you don't build a product that will directly
              compete with FlowBite either as a UI kit, theme, or template,
              it's fine.
            </p>
            <p className="mb-4 text-gray-600 dark:text-gray-400">
              Find out more information by{" "}
              <link
                to="/license"
                className="font-medium underline text-primary-600 hover:no-underline dark:text-primary-500"
              />
              reading the license.
            </p>
          </div>
          <div className="mb-10">
            <h3 className="mb-4 text-lg font-medium text-gray-900 dark:text-white">
              What does "free updates" include?
            </h3>
            <p className="mb-4 text-gray-600 dark:text-gray-400">
              The free updates that will be provided is based on the{" "}
              <a
                href="#"
                className="font-medium underline text-primary-600 hover:no-underline dark:text-primary-500"
              >
                roadmap
              </a>{" "}
              that we have laid out for this project. It is also possible that
              we will provide extra updates outside of the roadmap as well.
            </p>
          </div>
          <div className="mb-10">
            <h3 className="mb-4 text-lg font-medium text-gray-900 dark:text-white">
              What does the free version include?
            </h3>
            <p className="mb-4 text-gray-600 dark:text-gray-400">
              The{" "}
              <a
                href="#"
                className="font-medium underline text-primary-600 hover:no-underline dark:text-primary-500"
              >
                free version
              </a>{" "}
              of FlowBite includes a minimal style guidelines, component
              variants, and a dashboard page with the mobile version alongside
              it.
            </p>
            <p className="mb-4 text-gray-600 dark:text-gray-400">
              You can use this version for any purposes, because it is
              open-source under the MIT license.
            </p>
          </div>
          <div className="mb-10">
            <h3 className="mb-4 text-lg font-medium text-gray-900 dark:text-white">
              What is the difference between FlowBite and Tailwind UI?
            </h3>
            <p className="mb-4 text-gray-600 dark:text-gray-400">
              Although both FlowBite and Tailwind UI are built for integration
              with Tailwind CSS, the main difference is in the design, the
              pages, the extra components and UI elements that FlowBite
              includes.
            </p>
            <p className="mb-4 text-gray-600 dark:text-gray-400">
              Additionally, FlowBite is a project that is still in
              development, and later it will include both the application,
              marketing, and e-commerce UI interfaces.
            </p>
          </div>
        </div>
        <div>
          <div className="mb-10">
            <h3 className="mb-4 text-lg font-medium text-gray-900 dark:text-white">
              How do I purchase a license for my entire team?
            </h3>
            <p className="mb-4 text-gray-600 dark:text-gray-400">
              You can purchase a license that you can share with your entire
              team here:
            </p>
            <ul className="pl-4 mb-4 list-disc">
              <li className="mb-2 text-gray-600">
                <span className="font-medium cursor-pointer text-primary-600 hover:underline dark:text-primary-500">
                  Figma Files - Buy a team license for $299 USD
                </span>
              </li>
              <li className="mb-2 text-gray-600">
                <span className="font-medium cursor-pointer text-primary-600 hover:underline dark:text-primary-500">
                  Figma Files + Tailwind CSS code pre-order - Buy a team
                  license for <del>$699</del> $559 USD
                </span>
              </li>
              <li className="mb-4 text-gray-600 dark:text-gray-400">
                <span className="font-medium cursor-pointer text-primary-600 hover:underline dark:text-primary-500">
                  Tailwind CSS code pre-order - Buy a team license for{" "}
                  <del>$399</del> $319 USD
                </span>
              </li>
            </ul>
            <p className="mb-4 text-gray-600 dark:text-gray-400">
              Please use a single account to share with your team to access
              the download files.
            </p>
          </div>
          <div className="mb-10">
            <h3 className="mb-4 text-lg font-medium text-gray-900 dark:text-white">
              Can I build/sell templates or themes using FlowBite?
            </h3>
            <p className="mb-4 text-gray-600 dark:text-gray-400">
              It is not allowed to use FlowBite or parts of the project to
              build themes, templates, UI kits, or page builders.
            </p>
            <p className="mb-4 text-gray-600 dark:text-gray-400">
              Find out more information by{" "}
              <link
                to="/license"
                className="font-medium underline text-primary-600 hover:no-underline dark:text-primary-500"
              />
              reading the license.
            </p>
          </div>
          <div className="mb-10">
            <h3 className="mb-4 text-lg font-medium text-gray-900 dark:text-white">
              Can I use FlowBite in open-source projects?
            </h3>
            <p className="mb-4 text-gray-600 dark:text-gray-400">
              Generally, it is accepted to use FlowBite in open-source
              projects, as long as it is not a UI library, a theme, a
              template, a page-builder that would be considered as an
              alternative to FlowBite itself.
            </p>
            <p className="mb-4 text-gray-600 dark:text-gray-400">
              With that being said, feel free to use this design kit for your
              open-source projects.
            </p>
            <p className="mb-4 text-gray-600 dark:text-gray-400">
              Find out more information by{" "}
              <link
                to="/license"
                className="font-medium underline text-primary-600 hover:no-underline dark:text-primary-500"
              />
              reading the license.
            </p>
          </div>
          <div className="mb-10">
            <h3 className="mb-4 text-lg font-medium text-gray-900 dark:text-white">
              Can I use FlowBite for commercial purposes?
            </h3>
            <p className="mb-4 text-gray-600 dark:text-gray-400">
              Absolutely! You can use this design kit to build any type of
              commercial business, whether it's a SaaS, an e-commerce app, an
              application UI.
            </p>
            <p className="mb-4 text-gray-600 dark:text-gray-400">
              As long as it is not a design resource that you will re-sell, it
              is alright to use it for commercial purposes.
            </p>
            <p className="mb-4 text-gray-600 dark:text-gray-400">
              Find out more information by{" "}
              <link
                to="/license"
                className="font-medium underline text-primary-600 hover:no-underline dark:text-primary-500"
              />
              reading the license.
            </p>
          </div>
          <div className="mb-10">
            <h3 className="mb-4 text-lg font-medium text-gray-900 dark:text-white">
              Can I get an invoice?
            </h3>
            <p className="mb-4 text-gray-600 dark:text-gray-400">
              After opening the checkout process, you will be able to add all
              of your personal or company information that you want to be
              available on the invoice. After the purchase, you will get an
              email with the invoice.
            </p>
            <p className="mb-4 text-gray-600 dark:text-gray-400">
              If you forgot to complete the information, or you didn't get the
              invoice by email, feel free to{" "}
              <a
                href="#"
                className="font-medium underline text-primary-600 hover:no-underline dark:text-primary-500"
                target="_blank"
                rel="noreferrer"
              >
                contact us
              </a>{" "}
              and help you out with the invoice.
            </p>
          </div>
        </div>
        <div>
          <div className="mb-10">
            <h3 className="mb-4 text-lg font-medium text-gray-900 dark:text-white">
              When will I get access to the Tailwind CSS code if I pre-ordered
              it?
            </h3>
            <p className="mb-4 text-gray-600 dark:text-gray-400">
              The official date that we have set out to release the code
              version of FlowBite is the{" "}
              <span className="font-medium text-gray-900">
                25th of September, 2021
              </span>
              . We are already working on the integration and if you have a
              pre-order, you will also get frequent updates about the
              progress.
            </p>
            <p className="mb-4 text-gray-600 dark:text-gray-400">
              You'll be one of the first to know when it will be available.
            </p>
          </div>
          <div className="mb-10">
            <h3 className="mb-4 text-lg font-medium text-gray-900 dark:text-white">
              What is your refund policy?
            </h3>
            <p className="mb-4 text-gray-600 dark:text-gray-400">
              If you are unhappy with your purchase, just{" "}
              <a
                href="#"
                className="font-medium underline text-primary-600 hover:no-underline dark:text-primary-500"
                target="_blank"
                rel="noreferrer"
              >
                contact us
              </a>{" "}
              within 30 days and we'll issue a full refund.
            </p>
          </div>
          <div className="mb-10">
            <h3 className="mb-4 text-lg font-medium text-gray-900 dark:text-white">
              Is it allowed to use the design assets, such as the fonts,
              icons, and illustrations?
            </h3>
            <p className="mb-4 text-gray-600 dark:text-gray-400">
              What you see is what you get. Which means that all icons, fonts,
              and illustrations can be used based on the licensing that we
              researched or purchased. For example, we purchased rights to use
              the illustrations in Flowbite.
            </p>
          </div>
          <div className="mb-10">
            <h3 className="mb-4 text-lg font-medium text-gray-900 dark:text-white">
              Where can I access my download files?
            </h3>
            <p className="mb-4 text-gray-600 dark:text-gray-400">
              After you purchased one of the plans, you will get two emails:
              one for the invoice, and another one with the download files.
            </p>
            <p className="mb-4 text-gray-600 dark:text-gray-400">
              Soon we will create a way that you will be able to access the
              download files from the FlowBite dashboard from this website.
            </p>
          </div>
          <div className="mb-10">
            <h3 className="mb-4 text-lg font-medium text-gray-900 dark:text-white">
              I have a company registered for VAT. Where can I add the VAT for
              the invoice?
            </h3>
            <p className="mb-4 text-gray-600 dark:text-gray-400">
              After initializing the checkout process from Paddle, you will be
              able to see a text "Add VAT code". Click on that, and add the
              VAT code for your company. This will also remove the extra VAT
              tax from the purchase.
            </p>
          </div>
          <div className="mb-10">
            <h3 className="mb-4 text-lg font-medium text-gray-900 dark:text-white">
              Why would I pre-order the Tailwind CSS code?
            </h3>
            <p className="mb-4 text-gray-600 dark:text-gray-400">
              If you decide to pre-order the Tailwind CSS code, which will
              arrive on the 25th of September 2021, you can get a base 20%
              price reduction and purchase it only for $119, instead of $149.
            </p>
          </div>
        </div>
      </div> */}
    </section>
  </div>)
}

export default Home;
